import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { UserCog, Plus, Trash2, Loader2, Search } from "lucide-react";
import { toast } from "sonner";

const API = window.location.origin;

export default function GarsonManagement() {
  const [garsonlar, setGarsonlar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [q, setQ] = useState("");

  const token = localStorage.getItem("auth_token");
  const headers = { Authorization: `Bearer ${token}` };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/api/garsonlar`, { headers });
      setGarsonlar(data.garsonlar || []);
    } catch (e) {
      toast.error("Garson listesi alınamadı");
    } finally { setLoading(false); }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);

  const add = async () => {
    const n = name.trim();
    if (!n) { toast.error("İsim girin"); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/api/garsonlar`, { name: n }, { headers });
      setName("");
      toast.success("Garson eklendi");
      await load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Eklenemedi"); }
    finally { setBusy(false); }
  };

  const del = async (g) => {
    if (!window.confirm(`"${g.name}" silinsin mi?`)) return;
    try {
      await axios.delete(`${API}/api/garsonlar/${g.id}`, { headers });
      toast.success("Silindi");
      setGarsonlar((prev) => prev.filter((x) => x.id !== g.id));
    } catch (e) { toast.error("Silinemedi"); }
  };

  const filtered = garsonlar.filter((g) => !q.trim() || g.name.toLowerCase().includes(q.trim().toLowerCase()));

  return (
    <div data-testid="garson-management-page">
      <div className="page-header">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-sky-500 to-sky-700 flex items-center justify-center">
            <UserCog className="w-5 h-5 text-white" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-white leading-none">Garsonlar</h1>
            <p className="text-[11px] text-slate-400 mt-1">Canlı Defter garson listesini yönetin ({garsonlar.length} garson)</p>
          </div>
        </div>
      </div>

      <div className="page-body">
        <div className="max-w-2xl">
          {/* Ekleme */}
          <div className="flex items-center gap-2 mb-5">
            <input
              data-testid="garson-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") add(); }}
              placeholder="Yeni garson adı (ör. Fatih Berker)"
              className="flex-1 bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-slate-100 placeholder-slate-500 outline-none focus:border-sky-500/50"
            />
            <button
              data-testid="garson-add-btn"
              onClick={add}
              disabled={busy}
              className="flex items-center gap-2 bg-sky-600 hover:bg-sky-500 text-white text-sm font-semibold px-4 py-2.5 rounded-lg transition-colors disabled:opacity-50">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />} Ekle
            </button>
          </div>

          {/* Arama */}
          <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-lg px-3 py-2 mb-3">
            <Search className="w-4 h-4 text-slate-500" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Garson ara…"
              className="flex-1 bg-transparent outline-none text-sm text-slate-200 placeholder-slate-500" data-testid="garson-search" />
          </div>

          {/* Liste */}
          {loading ? (
            <div className="text-center text-slate-400 py-10 text-sm">Yükleniyor…</div>
          ) : (
            <div className="space-y-1.5" data-testid="garson-list">
              {filtered.map((g) => (
                <div key={g.id} data-testid={`garson-row-${g.id}`}
                  className="flex items-center justify-between bg-white/[0.03] border border-white/[0.06] rounded-lg px-4 py-2.5">
                  <span className="text-sm text-slate-100 font-medium">{g.name}</span>
                  <button data-testid={`garson-del-${g.id}`} onClick={() => del(g)}
                    className="p-1.5 text-slate-500 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-colors" title="Sil">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              ))}
              {filtered.length === 0 && <div className="text-center text-slate-500 py-8 text-sm">Kayıt yok.</div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
